import React from "react";
import "./style.scss";
import { BankDetails, QRList } from "./helper";
import qrCode from "assets/images/png/qr-code.jpg";

function BankDetailsCard() {
  return (
    <div className="flex gap-8 bank-details-container">
      <div className="detail-card gap-8">
        <div className="scan-me">
          <img
            src={qrCode}
            alt="qr code"
            onContextMenu={(e) => {
              e.preventDefault();
              alert("Saving or downloading this image is not allowed.");
            }}
            onDragStart={(e) => e.preventDefault()}
            style={{
              userSelect: "none",
              pointerEvents: "auto",
            }}
          />
          <span className="scan-text">Scan me </span>
        </div>
        <div className="flex flex-col qr-details">
          <span className="title">Quick and easy payment methods.</span>
          <span className="data-value mt-3">
            We understand that you don’t have time to wait for it, so we have
            made it as easy as possible for you to pay. Scan and use the below
            options:
          </span>
          <ul className="mt-2-5 flex flex-col gap-1 list">
            {QRList.map((item, i) => (
              <li key={i} className="data-value">
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="detail-card flex-col gap-3 items-start bank-section">
        <span className="title">Direct payment - Federal Bank</span>
        <div className="flex flex-col gap-2">
          <span className="data-value">MADHYAMAM CAPITAL ENTERPRISES LLP.</span>

          {BankDetails.map((item) => (
            <div className="flex items-center gap-1" key={item?.label}>
              <span className="data-value label">{item?.label}:</span>
              <span className="data-value">{item?.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BankDetailsCard;
